export default "__VITE_ASSET__1447729b__"